import { Card, CardContent } from "@/components/ui/card"
import { Loader2 } from "lucide-react"

interface LoadingStateProps {
  message?: string
}

export function LoadingState({ message = "Loading..." }: LoadingStateProps) {
  return (
    <Card className="bg-card border-border/50 rounded-2xl">
      <CardContent className="p-12 flex flex-col items-center justify-center text-center space-y-6">
        <Loader2 className="w-12 h-12 text-primary animate-spin" />
        <p className="text-lg text-muted-foreground font-medium">
          {message}
        </p>
      </CardContent>
    </Card>
  )
}
